var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px","width":"300px"}},[_c('Field',{attrs:{"type":1,"addbtn":"","placeholder":"开课城市"}}),_vm._v(" "),_c('Alert',{attrs:{"type":"info"}},[_vm._v("提示：自2025-04-18日起，开课城市会自动和crm系统中招生中的城市进行同步，同步时间为每天00:05。若在自动同步之前需要新增/删除开课城市，可在此板块操作。")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8fbe13c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/City.vue
// module id = null
// module chunks = 